<template>
    <div class="border border-echoes-border-light rounded-lg mb-2 bg-echoes-background-gray duration-200">
        <div @click="toggleCollapse" 
             class="flex justify-between items-center p-3 sm:p-4 cursor-pointer bg-echoes-background-black transition-all duration-200 rounded-lg" :class="{'rounded-b-none': isOpen}">
            <div class="flex items-center space-x-2 sm:space-x-4 flex-1 min-w-0">
                <span class="text-sm font-medium text-white truncate">{{ props.schema.name }}</span>
                <span v-if="props.schema.size" class="text-xs px-2 py-1 rounded-full bg-echoes-background-black/30 text-echoes-primary whitespace-nowrap">
                    {{ formatSize(props.schema.size) }}
                </span>
            </div>
            <i class="mdi text-echoes-primary ml-2" :class="[isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down', 'transform transition-transform duration-200']"></i>
        </div>

        <div v-show="isOpen" class="border-t border-echoes-border-light">
            <div class="overflow-x-auto custom-scrollbar-x">
                <div class="max-h-[400px] overflow-y-auto custom-scrollbar-y">
                    <table class="w-full border-collapse text-sm">
                        <thead class="bg-echoes-background-gray sticky top-0 z-10">
                            <tr class="border-b border-echoes-border-light">
                                <th class="px-6 py-3 text-left text-xs font-medium text-white/80 uppercase tracking-wider">
                                    Column name
                                </th>
                                <th class="px-6 py-3 text-left text-xs font-medium text-white/80 uppercase tracking-wider">
                                    Data type
                                </th>
                                <th class="px-6 py-3 text-left text-xs font-medium text-white/80 uppercase tracking-wider">
                                    Description
                                </th>
                            </tr>
                        </thead>
                        <tbody class="bg-echoes-background-gray divide-y divide-echoes-border-light">
                            <template v-if="props.schema.schema">
                                <tr v-for="(item, index) in props.schema.schema" :key="index"
                                    class="hover:bg-echoes-background-black/50 transition-colors duration-200">
                                    <td class="px-6 py-3 text-sm font-medium text-white max-w-[200px] truncate">
                                        {{ item.name }}
                                    </td>
                                    <td class="px-6 py-2.5 whitespace-nowrap">
                                        <span class="px-2 py-0.5 text-xs font-medium rounded-full bg-echoes-background-black/30 text-echoes-primary">
                                            {{ item.type }}
                                        </span>
                                    </td>
                                    <td class="px-6 py-2.5 text-sm text-white/80">
                                        <div class="line-clamp-2">{{ item.description || '-' }}</div>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps } from 'vue';

const props = defineProps({
    schema: {
        type: Object,
        required: true
    }
});

const isOpen = ref(false);

const toggleCollapse = () => {
    isOpen.value = !isOpen.value;
};

const formatSize = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    else if (bytes < 1048576) return (bytes / 1024).toFixed(2) + ' KB';
    else return (bytes / 1048576).toFixed(2) + ' MB';
};
</script>
